/* Mystery boxes (tms-backend boxes.py, Rich 10-17).
 *
 * Two pages share this file:
 *   [data-mbx]        the box product page: odds, every trick and recent pulls, from
 *                     /apps/tms/boxes?handle=…, the record the draw itself uses.
 *   [data-mbx-reveal] /pages/mystery-box: the card flip. Shows one order's boxes
 *                     (?order=…&status=<order-status link>, from the order email) or,
 *                     signed in, every box the customer has opened.
 *
 * The draw already happened on the server when the order was paid; the flip only shows
 * it. Nothing here can change what was drawn.
 */
(function () {
  'use strict';

  var MS = window.MagicStore || {};
  var rate = (window.Shopify && window.Shopify.currency && Number(window.Shopify.currency.rate)) || 1;
  function money(dollars, whole) {
    var cents = Math.round(Number(dollars || 0) * rate * 100);
    if (whole && MS.formatMoney) return MS.formatMoney(Math.round(cents / 100) * 100).replace(/\.00(?=\D|$)/, '');
    return MS.formatMoney ? MS.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
  }
  function esc(t) {
    return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function img(u, w) { return u ? esc(u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w) : ''; }
  /* Rarity colours (Rich 10-17): 1 star blue, 2 purple, 3 gold. Used only in the reveal and the odds,
     never on buttons (brand: blue = tap, gold = Black Friday). */
  function rc(n) { return n >= 3 ? '242,179,61' : n === 2 ? '155,92,246' : '47,125,246'; }
  function dot(n) { return '<span class="mbx-dot" style="--rc:' + rc(n) + '" aria-hidden="true"></span>'; }
  function stars(n) {
    var s = '';
    for (var i = 0; i < 3; i++) s += '<i' + (i < n ? ' class="on"' : '') + '>★</i>';
    return '<span class="mbx-stars" aria-label="' + n + ' of 3 stars">' + s + '</span>';
  }
  function ago(t) {
    var m = Math.max(1, Math.round((Date.now() / 1000 - t) / 60));
    if (m < 60) return m + ' min ago';
    var h = Math.round(m / 60);
    if (h < 24) return h + ' hr ago';
    var d = Math.round(h / 24);
    return d === 1 ? 'yesterday' : d + ' days ago';
  }
  function post(path, data) {
    return fetch('/apps/tms/boxes' + path, {method: 'POST', credentials: 'same-origin',
      headers: {Accept: 'application/json', 'Content-Type': 'application/json'}, body: JSON.stringify(data)})
      .then(function (r) { return r.json().then(function (j) { j.__status = r.status; return j; }); });
  }
  function get(path) {
    return fetch('/apps/tms/boxes' + path, {credentials: 'same-origin', headers: {Accept: 'application/json'}})
      .then(function (r) { return r.json().then(function (j) { j.__status = r.status; return j; }); });
  }

  /* ---- the box page ---- */
  function page(root) {
    var q = function (s) { return root.querySelector(s); };
    // Rich 10-18: the playing-card pack says "deck", the first pack "trick" (section settings)
    var one1 = root.getAttribute('data-noun') || 'trick', many1 = root.getAttribute('data-nouns') || one1 + 's';
    get('?handle=' + encodeURIComponent(root.getAttribute('data-mbx'))).then(function (b) {
      if (!b || b.error) { q('[data-mbx-odds]').innerHTML = '<div class="mbx-load">The odds aren’t available right now. Please check back soon.</div>'; return; }
      var up = q('[data-mbx-upto]');
      up.hidden = false;
      // Rich 10-18: gamified (option C). Still singular ("a trick"), never "one of 3 exclusives", which read as three items.
      var gold = b.tiers.some(function (t) { return t.stars >= 3; });
      // Rich 10-18: make it feel like a pull, not price maths. The guarantee stays in the line under the buttons.
      q('[data-mbx-lede]').innerHTML = 'Every pack is sealed with one of <b>' + b.count + ' ' + esc(many1) + '</b>, from crowd-pleasers to showstoppers. ' +
        'Your pull is locked in the moment you pay. ' + (gold ? 'Will yours be <span class="mbx-gold">gold</span>?' : 'Will yours be the big one?');
      q('[data-mbx-sticky]').innerHTML = 'Feeling lucky? <span class="rip-mark rip-mark--xs" data-text="Rip it.">Rip it.</span>';
      var tiers = b.tiers.slice();
      q('[data-mbx-odds]').innerHTML = tiers.map(function (t, k) {
        var lo = Math.min.apply(null, t.items.map(function (i) { return i.value; })), hi = Math.max.apply(null, t.items.map(function (i) { return i.value; }));
        return '<div class="mbx-tier" style="--rc:' + rc(t.stars) + '"><span>' + dot(t.stars) + '<br><b>' + esc(t.name) + '</b></span><span class="pc">' + t.odds + '%</span>' +
          '<small>' + t.items.length + ' ' + esc(t.items.length === 1 ? one1 : many1) + ' · worth ' + money(lo, true) + (hi !== lo ? '–' + money(hi, true) : '') + '</small>' +
          '<span class="mbx-bar"><i style="width:' + Math.max(t.odds, 1.5) + '%"></i></span></div>';
      }).join('');
      var ev = q('[data-mbx-ev]');
      // Rich 10-18: a sold-out trick drops out and the rest of its tier share its chance; the tier's odds never move
      ev.innerHTML = 'Every ' + esc(one1) + ' still in a tier is equally likely. A sold-out ' + esc(one1) + ' sits out and the rest of its tier share its chance, so the tier odds above never change.';
      ev.hidden = false;
      q('[data-mbx-count]').textContent = b.count + ' in the pack.';
      q('[data-mbx-pool]').innerHTML = tiers.map(function (t) {
        var gone = t.items.filter(function (i) { return i.out; }).length;
        return '<div class="mbx-group" style="--rc:' + rc(t.stars) + '">' + dot(t.stars) + ' <span class="mbx-rcname">' + esc(t.name) + '</span> <small>' + t.odds + '% chance' + (gone ? ' · ' + gone + ' sold out' : '') + '</small></div><div class="mbx-grid">' +
          t.items.map(function (i) {
            return '<a class="mbx-item' + (i.out ? ' is-out' : '') + '" href="/products/' + esc(i.handle) + '"><img src="' + img(i.image, 640) + '" alt="" loading="lazy" width="640" height="360">' +
              '<span class="n">' + esc(i.title) + '</span><span class="s"><span>' + (i.out ? 'Sold out · sitting this one out' : 'Worth ' + money(i.value, true)) + '</span></span></a>';
          }).join('') + '</div>';
      }).join('');
      if (b.pulls && b.pulls.length) {
        q('[data-mbx-pulls]').innerHTML = b.pulls.map(function (p) {
          return '<li><img src="' + img(p.image, 240) + '" alt="" loading="lazy"><span><b>' + esc(p.title) + '</b><small>' + esc(p.tier) + ' · worth ' + money(p.value, true) + '</small></span><time>' + ago(p.at) + '</time></li>';
        }).join('');
        q('[data-mbx-pulls-wrap]').hidden = false;
      }
    }).catch(function () {
      q('[data-mbx-odds]').innerHTML = '<div class="mbx-load">The odds aren’t available right now. Please check back soon.</div>';
    });
  }

  /* ---- the reveal ---- */
  var SEEN = 'mbx-flipped';
  function seen() { try { return JSON.parse(localStorage.getItem(SEEN) || '[]'); } catch (e) { return []; } }
  function markSeen(key) { try { var s = seen(); if (s.indexOf(key) < 0) { s.push(key); localStorage.setItem(SEEN, JSON.stringify(s.slice(-200))); } } catch (e) {} }

  /* Pack skins (Rich 10-18, playing-card pack): the reveal section's blocks map a box (its product handle) to its own
     pack image, noun and "Rip another" link. Rows carry box_id; anything unmapped uses the section's own pack. */
  /* After the flip the card already shows the trick's name (Rich 10-19): the heading is just the tier, as a badge above it. */
  function badge(r) { return '<span class="rp-badge">' + esc(r.tier) + '</span>'; }

  function skins(root) {
    if (!root.__skins) { try { root.__skins = JSON.parse(root.getAttribute('data-skins') || '{}'); } catch (e) { root.__skins = {}; } }
    return root.__skins;
  }
  function skinOf(root, r) { return (r && skins(root)[r.box_id]) || {}; }

  /* What shows under the card. Duplicates (Rich 10-18): the first pull is always shown; if they already own it,
     say where from and offer one re-pull from the SAME tier (a trick they don't have yet), forfeit the pack for its
     price in +Coin (signed-in buyers only; nothing ships for it; never called a refund) or keep it. */
  function coin(c) {
    var a = Number(c && c.amount || 0);
    return '$' + (a % 1 ? a.toFixed(2) : String(a)) + (c && c.currency ? ' ' + esc(c.currency) : '');
  }
  function day(iso) {
    var d = new Date(String(iso || '') + 'T12:00:00Z');
    return isNaN(d) ? '' : d.toLocaleDateString(undefined, {month: 'long', day: 'numeric', year: 'numeric'});
  }
  function after(root, r, last) {
    var sk = skinOf(root, r), noun = sk.noun || 'trick';
    var more = last ? '<a class="mbx-btn" href="' + esc(sk.url || root.getAttribute('data-box-url') || '/') + '">Rip another</a>'
                    : '<button class="mbx-btn" type="button" data-next>Next pack</button>';
    var about = '<a class="mbx-btn ghost" href="/products/' + esc(r.handle) + '">About ' + esc(r.title) + ' ›</a>';
    if (r.choose) {         // a duplicate looks like any pull (Rich 10-18): only this line and the buttons change
      // Order = what we'd rather they pick: Pull again (same cost as keeping, happier), Keep it as a gift, then Forfeit as a quiet link.
      var back = coin({amount: r.paid, currency: ''}), any = r.can_repull || r.can_credit;
      return '<p>' + esc(r.duplicate) + '</p>' +
        '<div class="rp-stack">' +
        (r.can_repull ? '<button class="mbx-btn rp-once" type="button" data-repull>Pull again<span class="rp-left">1 left</span></button>' : '') +
        '<button class="mbx-btn' + (r.can_repull ? ' rp-outline' : '') + '" type="button" data-keep>Keep it</button>' +
        (r.can_credit ? '<button class="rp-link" type="button" data-credit>Or forfeit this pull and get ' + back + ' back in&nbsp;+Coin&nbsp;(1&nbsp;left)</button>' : '') + '</div>' +
        (any ? '<p class="mz-dup mz-small">One Pull again and one Forfeit per&nbsp;account.</p>' : '');
    }
    if (r.credit) {
      var c = r.credit;
      return '<p><b class="mz-rc">Pull forfeited.</b><br>' +
        (c.state === 'issued' ? coin(c) + '&nbsp;in&nbsp;+Coin is in your account.' + (day(c.expires) ? '<br>Spend it by ' + day(c.expires).replace(/ /g, '&nbsp;') + '.' : '')
                              : 'We’re adding ' + coin(c) + ' in +Coin to your account. If it isn’t there within a day, reply to your order email.') + '</p>' +
        '<div class="rp-stack"><a class="mbx-btn" href="/collections/all">Spend it</a>' + more.replace('class="mbx-btn"', 'class="mbx-btn ghost"') + '</div>' +
        '<p class="mz-dup mz-small">Nothing ships for this pull.</p>';
    }
    if (r.first) {
      return '<p><b class="mz-rc">New pull!</b></p>' +
        '<p class="mz-dup">Your first pull was ' + esc(r.first.title) + ', which you already had.</p>' + more + about;
    }
    if (r.duplicate) {
      return '<p>' + esc(r.duplicate) + '</p>' +
        (r.decided === 'keep:timeout' ? '<p class="mz-dup mz-small">We kept it for you so your order could ship.</p>' : '') + more + about;
    }
    return more + about;
  }

  /* ---- the pack page: a practice rip (Rich 10-18). Only ever a "?" card; the colour is random, never a trick. ---- */
  function tryRip(root) {
    var R = window.MysteryRip; if (!R) return;
    var st = root.querySelector('[data-try-stage]'), out = root.querySelector('[data-try-out]'), tap = root.querySelector('[data-try-tap]');
    function go() {
      out.classList.remove('is-on'); out.innerHTML = ''; tap.hidden = false;
      var pick = ['47,125,246', '47,125,246', '47,125,246', '155,92,246', '155,92,246', '242,179,61'][Math.floor(Math.random() * 6)];
      var api = R.pack(st, {pack: root.getAttribute('data-pack'), back: root.getAttribute('data-back'), rc: pick, seed: 7,
        onRip: function () {
          tap.hidden = true; api.peek();
          setTimeout(function () {
            out.innerHTML = '<p>That was a practice rip. A real pack holds a real ' + esc(root.getAttribute('data-noun') || 'trick') + '. Will yours be <b style="font-size:inherit;color:rgb(242,179,61)">Legendary</b>?</p>' +
              '<button class="rp-link" type="button" data-reseal>Reseal</button>';
            out.classList.add('is-on');
            out.querySelector('[data-reseal]').onclick = go;
          }, 900);
        }});
      tap.querySelector('button').onclick = api.rip;
    }
    go();
  }

  /* ---- the reveal: drag across the top to rip (Rich 10-18). One pack, or many: a pile + tray on phones, every pack
     laid out on a computer. Duplicates keep their Pull again / +Coin / Keep it choice under the card. ---- */
  function stars(r) { return r.stars || 1; }
  function reveal(root) {
    var R = window.MysteryRip;
    var A = {pack: root.getAttribute('data-pack'), back: root.getAttribute('data-back'), logo: root.getAttribute('data-logo')};
    var params = new URLSearchParams(location.search);
    var order = params.get('order') || '';
    var path = order ? '/reveal?order=' + encodeURIComponent(order) + '&status=' + encodeURIComponent(params.get('status') || '') +
      '&checkout=' + encodeURIComponent(params.get('checkout') || '') : '/mine';
    var body = root.querySelector('[data-mbx-body]');
    var boxUrl = esc(root.getAttribute('data-box-url') || '/');
    if (params.get('gift')) return friend(root, params.get('gift'), A, body, boxUrl);
    function packOf(r) { return skinOf(root, r).pack || A.pack; }
    function shareBtn(label, kind, data, r) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'rp-share'; b.textContent = label;
      b.onclick = function () { b.disabled = true; R.share(kind, Object.assign({pack: packOf(r), logo: A.logo}, data)).then(function () { b.disabled = false; }, function () { b.disabled = false; }); };
      return b;
    }
    get(path).then(function (d) {
      var rows = (d && d.boxes) || [];
      if (d.__status === 403 || (!order && !d.signed_in)) {
        body.innerHTML = '<p class="mbx-rv-note">Sign in to see your packs, or use the button on your order’s thank-you page.</p><a class="mbx-btn" href="/account/login?return_url=' + encodeURIComponent(location.pathname + location.search) + '">Sign in</a>';
        return;
      }
      if (!rows.length) {
        body.innerHTML = '<p class="mbx-rv-note">' + (order ? 'Sealing your pack. One moment…' : 'No packs yet.') + '</p>' +
          (order ? '' : '<a class="mbx-btn" href="' + boxUrl + '">See the pack</a>');
        if (order) setTimeout(function () { reveal(root); }, 3000);
        return;
      }
      if (!R) { body.innerHTML = '<p class="mbx-rv-note">Please refresh the page.</p>'; return; }
      var done = seen();
      function isNew(r) { return done.indexOf(r.key) < 0; }
      function opened(r) { markSeen(r.key); if (done.indexOf(r.key) < 0) done.push(r.key); }

      // Pull again / +Coin / Keep it for a duplicate, shared by every view; calls back with the updated row
      function wireChoice(scope, r, then) {
        function decide(choice, btn) {
          Array.prototype.forEach.call(scope.querySelectorAll('[data-repull],[data-credit],[data-keep]'), function (b) { b.disabled = true; });
          btn.textContent = choice === 'repull' ? 'Pulling…' : choice === 'credit' ? 'Forfeiting…' : 'Saving…';
          post('/choose', {key: r.key, choice: choice, order: r.order_id, status: params.get('status') || '', checkout: params.get('checkout') || ''}).then(function (res) {
            if (!res || !res.row || (res.error && res.row.choose)) throw new Error(res && res.error);   // +Coin refused: still choosing
            rows = rows.map(function (x) { return x.key === res.row.key ? res.row : x; });
            if (choice === 'repull') done = done.filter(function (k) { return k !== res.row.key; });
            then(res.row, choice);
          }).catch(function (e) {
            var gone = /already used/i.test(e && e.message || '');   // used on another pack meanwhile: once per account
            btn.textContent = gone ? 'Already used' : 'Try again';
            Array.prototype.forEach.call(scope.querySelectorAll('[data-repull],[data-credit],[data-keep]'), function (b) { b.disabled = gone && b === btn; });
          });
        }
        var rp = scope.querySelector('[data-repull]'), cp = scope.querySelector('[data-credit]'), kp = scope.querySelector('[data-keep]');
        if (rp) rp.onclick = function () { decide('repull', rp); };
        if (cp) cp.onclick = function () { decide('credit', cp); };
        if (kp) kp.onclick = function () { decide('keep', kp); };
      }

      /* one pack */
      function one(r, last, onNext) {
        body.innerHTML = '<div class="rp-one" style="--rc:' + rc(stars(r)) + '">' +
          '<div class="rip-lockup rip-lockup--sm" aria-hidden="true"><span class="rip-mark" data-text="Rip it.">Rip it.</span><span class="rip-sub">Magic Mystery Pack</span></div><p class="rp-top">Order ' + esc(r.order) + ' · <span class="mz-ticket">1 pull</span></p>' +
          '<h1 class="rp-h" data-h>' + (r.first ? 'Your new pull is here.' : 'Your pack is here.') + '</h1>' +
          '<p class="rp-sub" data-sub>Pull the tear across to rip it open.</p>' +
          '<div data-st></div><div class="rp-out" data-out></div>' +
          '<div class="rp-fallback" data-fb>Can’t swipe? <button type="button">Tap to rip</button></div>' +
          '<div class="rp-tools" data-tools></div></div>';
        var wrap = body.querySelector('.rp-one'), out = wrap.querySelector('[data-out]'), tools = wrap.querySelector('[data-tools]');
        var gs = r.gift && r.gift.state;
        if (gs === 'sent' || gs === 'ripped' || gs === 'gifted') return giftOwner(wrap, r, last, onNext);
        tools.appendChild(shareBtn('Share before you rip', 'sealed', {count: 1}, r));
        if (!gs) { var sb = document.createElement('button'); sb.type = 'button'; sb.className = 'rp-share'; sb.textContent = 'Send to a friend';
          sb.onclick = function () { sendPanel(tools, r, function (row) { one(row, last, onNext); }); }; tools.appendChild(sb); }
        function result() {
          out.innerHTML = after(root, r, last);
          wrap.classList.toggle('is-forfeit', !!r.credit);     // the card greys out: nothing ships for it
          out.classList.add('is-on');
          tools.innerHTML = ''; tools.appendChild(shareBtn('Share my pull', 'single', {best: r}, r));
          var nx = out.querySelector('[data-next]'); if (nx) nx.onclick = function () { onNext(); window.scrollTo(0, 0); };
          wireChoice(out, r, function (row, choice) { if (choice === 'repull') one(row, last, onNext); else { r = row; result(); } });
        }
        if (!isNew(r)) {                      // already ripped: show the card where it landed
          wrap.querySelector('[data-st]').outerHTML = '<div class="rp-stage" style="height:318px"><div style="position:absolute;left:50%;top:0;width:220px;aspect-ratio:63/88;transform:translateX(-50%)">' + R.face(r) + '</div></div>';
          wrap.querySelector('.rp-stage .rp-art').style.cssText = 'position:absolute;inset:0';
          wrap.querySelector('[data-h]').innerHTML = badge(r);
          wrap.querySelector('[data-sub]').textContent = ''; wrap.querySelector('[data-fb]').hidden = true;
          result(); return;
        }
        var api = R.pack(wrap.querySelector('[data-st]'), {pack: packOf(r), back: A.back, seed: 11,
          onPull: function (on) { wrap.classList.toggle('is-pulling', on); },
          onRip: function () {
            opened(r); wrap.querySelector('[data-fb]').hidden = true; tools.innerHTML = '';
            api.reveal(r, function (phase) {
              if (phase === 'flip') { wrap.querySelector('[data-h]').innerHTML = badge(r); wrap.querySelector('[data-sub]').textContent = ''; }
              else result();
            });
          }});
        wrap.querySelector('[data-fb] button').onclick = api.rip;
      }

      /* ---- send a pack to a friend (Rich 10-18) ---- */
      function owner(extra) { return Object.assign({status: params.get('status') || '', checkout: params.get('checkout') || ''}, extra); }
      function shareLink(url, from) {
        var text = 'Rip this pack for me: ';
        if (navigator.share) return navigator.share({title: 'A Magic Mystery Pack for you', text: text, url: url}).catch(function () {});
        return copy(url);
      }
      function copy(url) { return (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).catch(function () { window.prompt('Copy this link', url); }); }
      function sendPanel(tools, r, done) {
        // Rich 10-18: key in a friend's email, or just share a link. Email opens your own mail app, ready to send.
        tools.innerHTML = '<div class="rp-send"><label for="rp-mail">Friend’s email</label>' +
          '<input id="rp-mail" type="email" autocomplete="email" inputmode="email" placeholder="friend@example.com">' +
          '<label for="rp-note">Add a note (optional)</label>' +
          '<textarea id="rp-note" rows="2" maxlength="200" placeholder="Rip this for me. If it’s gold, I owe you a coffee."></textarea>' +
          '<div class="rp-row"><button class="mbx-btn" type="button" data-mail>Email it</button><button class="mbx-btn ghost" type="button" data-link>Share a link</button></div>' +
          '<p class="rp-fine">They rip it on their phone, no account needed. The pull was sealed when you paid, so it’s the same card either way. Then you choose: keep it, or gift it to them.</p></div>';
        var mailBtn = tools.querySelector('[data-mail]'), linkBtn = tools.querySelector('[data-link]'), mail = tools.querySelector('#rp-mail');
        function make(how) {
          var to = mail.value.trim();
          if (how === 'mail' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(to)) { mail.focus(); mail.setAttribute('aria-invalid', 'true'); return; }
          mailBtn.disabled = linkBtn.disabled = true;
          var note = tools.querySelector('textarea').value;
          post('/gift/create', owner({order: r.order_id, key: r.key, note: note})).then(function (res) {
            if (!res || !res.row || !res.gift) throw new Error(res && res.error);
            done(res.row);
            var url = res.gift.url;
            if (how === 'mail') {
              location.href = 'mailto:' + encodeURIComponent(to) + '?subject=' + encodeURIComponent('A Magic Mystery Pack for you to rip') +
                '&body=' + encodeURIComponent((note ? note + '\n\n' : '') + 'Rip it here: ' + url);
            } else shareLink(url);
          }).catch(function () { mailBtn.disabled = linkBtn.disabled = false; });
        }
        mailBtn.onclick = function () { make('mail'); };
        linkBtn.onclick = function () { make('link'); };
      }
      // the buyer's side once a link exists: waiting, ripped (keep or gift), or gifted
      function giftOwner(wrap, r, last, onNext) {
        var g = r.gift, out = wrap.querySelector('[data-out]'), tools = wrap.querySelector('[data-tools]');
        wrap.querySelector('[data-fb]').hidden = true;
        var st = wrap.querySelector('[data-st]');
        if (g.state === 'sent') {
          st.outerHTML = '<div class="rp-stage" style="height:420px"><img src="' + esc(packOf(r)) + '" alt="A sealed pack" style="position:absolute;left:50%;top:64px;width:250px;transform:translateX(-50%)"></div>';
          wrap.querySelector('[data-h]').textContent = 'Sent to a friend.';
          wrap.querySelector('[data-sub]').textContent = 'Waiting for them to rip it.';
          out.innerHTML = '<div class="rp-row"><button class="mbx-btn" type="button" data-again>Send the link again</button><button class="rp-link" type="button" data-copy>Copy link</button></div>' +
            '<button class="rp-link" type="button" data-cancel>Cancel the link and rip it yourself</button>';
          out.classList.add('is-on');
          out.querySelector('[data-again]').onclick = function () { shareLink(g.url); };
          out.querySelector('[data-copy]').onclick = function (e) { copy(g.url).then(function () { e.target.textContent = 'Copied'; }); };
          out.querySelector('[data-cancel]').onclick = function (e) {
            e.target.disabled = true;
            post('/gift/cancel', owner({order: r.order_id, key: r.key})).then(function (res) { if (res && res.row) one(res.row, last, onNext); });
          };
          return;
        }
        st.outerHTML = '<div class="rp-stage" style="height:318px"><div style="position:absolute;left:50%;top:0;width:220px;aspect-ratio:63/88;transform:translateX(-50%)">' + R.face(r) + '</div></div>';
        wrap.querySelector('.rp-stage .rp-art').style.cssText = 'position:absolute;inset:0';
        if (g.state === 'gifted') {
          wrap.querySelector('[data-h]').textContent = 'Gifted.';
          wrap.querySelector('[data-sub]').innerHTML = esc(r.title) + ' is theirs. They sign in to claim it, and it goes in their bag for free.';
          out.innerHTML = '<a class="mbx-btn" href="' + boxUrl + '">Rip another</a>'; out.classList.add('is-on');
          return;
        }
        wrap.querySelector('[data-h]').textContent = 'Your friend ripped your pack.';
        wrap.querySelector('[data-sub]').innerHTML = '<span class="rp-c">' + esc(r.tier) + '.</span> ' + esc(r.title) + '.';
        out.innerHTML = '<div class="rp-row"><button class="mbx-btn" type="button" data-k="keep">Keep it</button>' +
          '<button class="mbx-btn ghost" type="button" data-k="gift">Gift it to them</button></div>' +
          '<p class="rp-fine">Gift it and they sign in to claim it; it goes in their bag for free and ships with their next order.</p>';
        out.classList.add('is-on');
        Array.prototype.forEach.call(out.querySelectorAll('[data-k]'), function (b) {
          b.onclick = function () {
            Array.prototype.forEach.call(out.querySelectorAll('[data-k]'), function (x) { x.disabled = true; });
            b.textContent = 'Saving…';
            post('/gift/decide', owner({order: r.order_id, key: r.key, choice: b.getAttribute('data-k')})).then(function (res) {
              if (res && res.row) { opened(res.row); one(res.row, last, onNext); return; }
              out.insertAdjacentHTML('beforeend', '<p class="rp-fine">' + esc((res && res.error) || 'Please try again.') + '</p>');
              Array.prototype.forEach.call(out.querySelectorAll('[data-k]'), function (x) { x.disabled = false; });
            });
          };
        });
      }

      /* many packs */
      function many(list) {
        var wide = window.matchMedia('(min-width: 900px)').matches;
        var total = list.length, got = list.filter(function (r) { return !isNew(r); });
        body.innerHTML = '<div class="rp-many rp-multi">' +
          '<div class="rip-lockup rip-lockup--sm" aria-hidden="true"><span class="rip-mark" data-text="Rip it.">Rip it.</span><span class="rip-sub">Magic Mystery Pack</span></div><p class="rp-top">Order ' + esc(list[0].order) + ' · ' + total + ' pulls</p>' +
          '<h1 class="rp-h" data-h></h1><p class="rp-sub" data-sub></p>' +
          '<p class="rp-count" data-count></p>' +
          (wide ? '<div class="rp-table" data-table></div>' : '<div data-st></div><div class="rp-tray" data-tray></div>') +
          '<div class="rp-out" data-out></div>' +
          '<div class="rp-fallback" data-fb><button type="button" data-all>Rip the rest at once</button></div>' +
          '<div class="rp-tools" data-tools></div></div>';
        var wrap = body.querySelector('.rp-many'), out = wrap.querySelector('[data-out]'), tools = wrap.querySelector('[data-tools]');
        tools.appendChild(shareBtn('Share before you rip', 'sealed', {count: total}, list[0]));
        var sendOne = document.createElement('button'); sendOne.type = 'button'; sendOne.className = 'rp-share'; sendOne.textContent = 'Send one to a friend';
        sendOne.onclick = function () {
          var r = list.filter(function (x) { return isNew(x) && !x.gift; })[0]; if (!r) return;
          sendPanel(tools, r, function () { reveal(root); });
        };
        tools.appendChild(sendOne);
        var auto = false, pending = [];
        function count() {
          got = list.filter(function (r) { return !isNew(r); });
          var n = function (s) { return got.filter(function (r) { return stars(r) === s; }).length; };
          var left = total - got.length;
          wrap.querySelector('[data-h]').textContent = left ? (left === total ? total + ' packs to rip.' : left + (left === 1 ? ' pack' : ' packs') + ' left.') : 'All ' + total + ' ripped.';
          wrap.querySelector('[data-sub]').textContent = left ? (wide ? 'Drag across the top of any pack.' : 'Pull the tear across. Pack ' + (got.length + 1) + ' of ' + total) : '';
          wrap.querySelector('[data-count]').innerHTML = got.length ? 'Pulled ' + got.length + ' of ' + total +
            ' · <span style="color:rgb(242,179,61)">' + n(3) + ' Legendary</span> · <span style="color:rgb(155,92,246)">' + n(2) + ' Rare</span> · <span style="color:rgb(47,125,246)">' + n(1) + ' Common</span>' : '';
          if (!left) finish();
        }
        // a duplicate waiting for an answer shows its choice under the table/tray before carrying on
        function ask(r, then) {
          wrap.style.setProperty('--rc', rc(stars(r)));
          out.innerHTML = '<p><b class="mz-rc">' + esc(r.title) + '</b></p>' + after(root, r, true).replace(/<a class="mbx-btn[^"]*" href="[^"]*">Rip another<\/a>/, '');
          out.classList.add('is-on');
          wireChoice(out, r, function (row, choice) {
            out.classList.remove('is-on'); out.innerHTML = '';
            list = list.map(function (x) { return x.key === row.key ? row : x; });
            then(row, choice);
          });
        }
        function finish() {
          wrap.querySelector('[data-fb]').hidden = true;
          if (out.querySelector('[data-keep]')) return;       // still waiting on a duplicate answer
          var best = list.slice().sort(function (a, b) { return stars(b) - stars(a); })[0];
          out.innerHTML = '<div class="rp-row"><a class="mbx-btn" href="' + esc(skinOf(root, list[0]).url || root.getAttribute('data-box-url') || '/') + '">Rip again</a><a class="mbx-btn ghost" href="/pages/account">See them in Your account ›</a></div>';
          out.classList.add('is-on');
          tools.innerHTML = ''; tools.appendChild(shareBtn('Share my haul', 'haul', {best: best, all: list.map(stars)}, best));
        }
        if (wide) {
          var table = wrap.querySelector('[data-table]'), apis = [];
          list.forEach(function (r, k) {
            var spot = document.createElement('div'); spot.className = 'rp-spot';
            var tilt = ((k * 37) % 9 - 4) * 0.9; spot.style.setProperty('--r', tilt + 'deg');
            var st = document.createElement('div'); spot.appendChild(st); table.appendChild(spot);
            if (!isNew(r)) { spot.innerHTML = '<div style="position:absolute;inset:8px 22px 0">' + R.face(r) + '</div>'; spot.querySelector('.rp-art').style.cssText = 'position:absolute;inset:0'; return; }
            spot.style.transform = 'rotate(' + tilt + 'deg)';
            var api = R.pack(st, {pack: packOf(r), back: A.back, seed: 11 + k, demo: false, shrink: false,
              onRip: function () {
                opened(r); spot.style.transform = 'none';
                api.reveal(r, function (phase) {
                  if (phase !== 'flip') return;
                  if (r.choose) ask(r, function (row, choice) {
                    if (choice === 'repull') { r = row; st.innerHTML = ''; var a2 = R.pack(st, {pack: packOf(row), back: A.back, seed: 31 + k, demo: false, shrink: false, onRip: function () { opened(row); a2.reveal(row, function (ph) { if (ph === 'flip') count(); }); }}); a2.rip(); }
                    else count();
                  });
                  count();
                });
              }});
            apis.push(api);
          });
          wrap.querySelector('[data-all]').onclick = function () {
            if (auto) return; auto = true; wrap.querySelector('[data-fb]').hidden = true;
            apis.forEach(function (a, k) { setTimeout(a.rip, k * 420); });
          };
          count();
          return;
        }
        // phone: the pack in hand on a neat pile, the tray fills as you rip
        var tray = wrap.querySelector('[data-tray]'), st = wrap.querySelector('[data-st]');
        tray.innerHTML = list.map(function (r) { return '<div class="rp-slot">' + (isNew(r) ? '' : R.face(r, true)) + '</div>'; }).join('');
        function nextPack() {
          var i = -1; list.some(function (r, k) { if (isNew(r)) { i = k; return true; } return false; });
          count();
          if (i < 0) { st.innerHTML = ''; st.style.height = '0'; return; }
          var r = list[i], left = list.filter(isNew).length - 1;
          var deck = '<div class="rp-deck">' + Array.apply(null, {length: Math.min(left, 9)}).map(function (_, k) {
            return '<img alt="" src="' + esc(packOf(list.filter(isNew)[k + 1] || r)) + '" style="transform:translateY(' + (-(k + 1) * 6) + 'px) scale(' + (1 - (k + 1) * 0.014) + ');filter:brightness(' + (0.7 - k * 0.045) + ')">';
          }).reverse().join('') + '</div>';
          var api = R.pack(st, {pack: packOf(r), back: A.back, seed: 11 + i, deck: deck, demo: got.length === 0,
            onPull: function (on) { wrap.classList.toggle('is-pulling', on); },
            onRip: function () {
              opened(r);
              api.reveal(r, function (phase) {
                if (phase === 'flip') { wrap.style.setProperty('--rc', rc(stars(r))); wrap.querySelector('[data-h]').innerHTML = badge(r); return; }
                function land(row) {
                  tray.children[i].innerHTML = R.face(row, true);
                  setTimeout(function () { nextPack(); if (auto) setTimeout(function () { var b = st.querySelector('.rp-grab'); if (b) api2rip(); }, 250); }, auto ? 300 : 900);
                }
                if (r.choose && !auto) ask(r, function (row, choice) {
                  if (choice === 'repull') { list[i] = row; nextPack(); } else land(row);
                }); else land(r);
              });
            }});
          current = api;
        }
        var current = null;
        function api2rip() { if (current) current.rip(); }
        wrap.querySelector('[data-all]').onclick = function () { if (auto) return; auto = true; wrap.querySelector('[data-fb]').hidden = true; api2rip(); };
        nextPack();
      }

      /* already ripped everything: their cards, with any duplicate still waiting for an answer */
      function gallery() {
        var best = rows.slice().sort(function (a, b) { return stars(b) - stars(a); })[0];
        body.innerHTML = '<div class="rp-many"><h1 class="rp-h">Your pulls.</h1><p class="rp-sub">' + rows.length + (rows.length === 1 ? ' pack' : ' packs') + ' ripped.</p>' +
          '<div class="rp-gallery">' + rows.map(function (r, k) {
            return '<figure><div class="rp-art-wrap" style="position:relative;aspect-ratio:63/88">' + R.face(r) + '</div><figcaption>' + esc(r.order) + '</figcaption>' +
              (r.choose ? '<button class="rp-link" type="button" data-pick="' + k + '">Duplicate: choose</button>' : '') + '</figure>';
          }).join('') + '</div><div class="rp-tools" data-tools></div>' +
          '<div class="rp-row" style="margin-top:18px"><a class="mbx-btn" href="' + boxUrl + '">Rip another</a></div></div>';
        Array.prototype.forEach.call(body.querySelectorAll('.rp-art-wrap .rp-art'), function (el) { el.style.cssText = 'position:absolute;inset:0'; });
        body.querySelector('[data-tools]').appendChild(shareBtn(rows.length > 1 ? 'Share my haul' : 'Share my pull', rows.length > 1 ? 'haul' : 'single', {best: best, all: rows.map(stars)}, best));
        Array.prototype.forEach.call(body.querySelectorAll('[data-pick]'), function (b) { b.onclick = function () { one(rows[+b.getAttribute('data-pick')], true, gallery); }; });
      }

      // orders open their own packs; signed in with nothing new shows the collection
      var mine = order ? rows : rows.filter(function (r) { return isNew(r) || (r.gift && (r.gift.state === 'sent' || r.gift.state === 'ripped')); });
      if (!mine.length) return gallery();
      var byOrder = {}; mine.forEach(function (r) { (byOrder[r.order_id || r.order] = byOrder[r.order_id || r.order] || []).push(r); });
      var groups = Object.keys(byOrder).map(function (k) { return byOrder[k]; }), gi = 0;
      (function run() {
        var g = groups[gi], lastGroup = gi + 1 >= groups.length;
        var nextGroup = function () { gi++; run(); };
        var gifty = g.some(function (r) { return r.gift; });
        if (g.length === 1) one(g[0], lastGroup, nextGroup);
        else if (gifty) (function seq(k) { one(g[k], lastGroup && k + 1 >= g.length, k + 1 < g.length ? function () { seq(k + 1); } : nextGroup); })(0);
        else many(g);
      })();
    }).catch(function () {
      body.innerHTML = '<p class="mbx-rv-note">We couldn’t reach your pack just now. Please refresh in a moment.</p>';
    });
  }

  /* ---- the friend's link: rip someone's pack, then (if they gift it) take it home in your own bag ---- */
  function friend(root, code, A, body, boxUrl) {
    var R = window.MysteryRip;
    get('/gift?code=' + encodeURIComponent(code)).then(function (v) {
      if (!v || v.error) { body.innerHTML = '<p class="mbx-rv-note">' + esc((v && v.error) || 'This link isn’t working.') + '</p><a class="mbx-btn" href="' + boxUrl + '">See the pack</a>'; return; }
      var card = Object.assign({}, v.card), from = esc(v.from);
      body.innerHTML = '<div class="rp-one" style="--rc:' + rc(card.stars || 1) + '">' +
        '<div class="rip-lockup rip-lockup--sm" aria-hidden="true"><span class="rip-mark" data-text="Rip it.">Rip it.</span><span class="rip-sub">Magic Mystery Pack</span></div><p class="rp-top">A pack from ' + from + '</p>' +
        '<h1 class="rp-h rp-oneline" data-h>' + (v.demo ? 'A free pack to rip.' : from + ' sent you a pack to rip.') + '</h1>' +
        '<p class="rp-sub" data-sub>' + (v.note ? '“' + esc(v.note) + '”' : 'Pull the tear across to rip it open.') + '</p>' +
        '<div data-st></div><div class="rp-out" data-out></div>' +
        '<div class="rp-fallback" data-fb>Can’t swipe? <button type="button">Tap to rip</button></div></div>';
      var wrap = body.querySelector('.rp-one'), out = wrap.querySelector('[data-out]');
      function showCard() {
        wrap.querySelector('[data-st]').outerHTML = '<div class="rp-stage" style="height:318px"><div style="position:absolute;left:50%;top:0;width:220px;aspect-ratio:63/88;transform:translateX(-50%)">' + R.face(card) + '</div></div>';
        wrap.querySelector('.rp-stage .rp-art').style.cssText = 'position:absolute;inset:0';
        wrap.querySelector('[data-fb]').hidden = true;
      }
      function afterRip(state) {
        wrap.querySelector('[data-h]').innerHTML = badge(card);
        wrap.querySelector('[data-sub]').textContent = '';
        if (state === 'gifted') {
          wrap.querySelector('[data-h]').innerHTML = 'It’s yours. ' + from + ' gave you <span class="rp-c">' + esc(card.title) + '</span>.';
          var signedIn = root.getAttribute('data-signed-in') === '1';
          if (!signedIn) {
            // Rich 10-18: they may not have an account. Signing in (or creating one) claims it, so only they can.
            out.innerHTML = '<p>Sign in or create an account to claim it. Then it goes in your bag for free and ships with your next order.</p>' +
              '<a class="mbx-btn" href="/account/login?return_url=' + encodeURIComponent(location.pathname + location.search) + '">Sign in to claim</a>';
          } else {
            out.innerHTML = '<p>It goes in your bag for free and ships with your next order.</p>' +
              '<button class="mbx-btn" type="button" data-bag>Add it to my bag</button><a class="mbx-btn ghost" href="' + boxUrl + '">Rip your own ›</a>';
            out.querySelector('[data-bag]').onclick = function (e) {
              var b = e.target; b.disabled = true; b.textContent = 'Adding…';
              post('/gift/claim', {code: code}).then(function (res) {
                if (!res || !res.bag) throw new Error((res && res.error) || 'Please try again.');
                return fetch('/cart/add.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
                  body: JSON.stringify({items: [{id: +res.bag.variant, quantity: 1, properties: {'Gift from': v.from}}]})})
                  .then(function () { location.href = '/discount/' + encodeURIComponent(res.bag.discount) + '?redirect=%2Fcart'; });
              }).catch(function (err) {
                b.disabled = false; b.textContent = 'Try again';
                out.insertAdjacentHTML('beforeend', '<p class="rp-fine">' + esc(err.message) + '</p>');
              });
            };
          }
        } else if (v.demo) {
          // the shareable test link: nothing real was pulled
          out.innerHTML = '<p>That was a demo pack, so this one’s just for fun. A real pack holds a real trick, worth more than you pay.</p>' +
            '<a class="mbx-btn" href="' + boxUrl + '">Rip a real pack</a><button class="rp-link" type="button" data-again>Rip another demo</button>';
          out.querySelector('[data-again]').onclick = function () { friend(root, code, A, body, boxUrl); window.scrollTo(0, 0); };
        } else if (state === 'kept') {
          out.innerHTML = '<p>' + from + ' is keeping this one.</p><a class="mbx-btn" href="' + boxUrl + '">Rip your own</a>';
        } else {
          out.innerHTML = '<p>You ripped it for ' + from + '. If ' + from + ' gives it to you, it goes in your bag for free.</p>' +
            '<a class="mbx-btn" href="' + boxUrl + '">Rip your own</a><button class="rp-link" type="button" data-check>Did ' + from + ' gift it? Check again</button>';
          out.querySelector('[data-check]').onclick = function () { friend(root, code, A, body, boxUrl); };
        }
        out.classList.add('is-on');
      }
      if (v.state !== 'sent') { showCard(); afterRip(v.state); return; }
      var api = R.pack(wrap.querySelector('[data-st]'), {pack: skinOf(root, v.card).pack || A.pack, back: A.back, seed: 13,
        onPull: function (on) { wrap.classList.toggle('is-pulling', on); },
        onRip: function () {
          wrap.querySelector('[data-fb]').hidden = true;
          post('/gift/ripped', {code: code});
          api.reveal(card, function (phase) { if (phase === 'done') afterRip('ripped'); });
        }});
      wrap.querySelector('[data-fb] button').onclick = api.rip;
    }).catch(function () { body.innerHTML = '<p class="mbx-rv-note">We couldn’t reach this pack just now. Please refresh in a moment.</p>'; });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mbx]'), page);
    Array.prototype.forEach.call(document.querySelectorAll('[data-mbx-reveal]'), reveal);
    Array.prototype.forEach.call(document.querySelectorAll('[data-mbx-try]'), tryRip);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
}());
